import {HomeCard} from './HomeCard';
import Manager from '../../../assets/images/manager.webp';
import {LearnerPortalPrimaryColor} from '../../../theme/ThemeLearnerPortalPalette';
import {routes} from '../../common/constants/routes';

export default function HomeManagerPortalCard(): JSX.Element {
  return (
    <HomeCard
      cover={Manager}
      smallCoverUrl={Manager}
      title="Manager Portal"
      background={LearnerPortalPrimaryColor.dark}
      path={routes.managerPortal.overview}
    />
  );
}
